/** Shared preset avatars for My Profile and Hire this agent. */
export type AgentProfilePreset = {
  url: string;
  label: string;
};

export const AGENT_PROFILE_PRESETS: AgentProfilePreset[] = [
  { url: "/images/profiles/Victoria.gif", label: "Victoria - Customer Support" },
  { url: "/images/profiles/Annie.png", label: "Annie - Healthcare Professional" },
  { url: "/images/profiles/Samantha.webp", label: "Samantha - Business Professional" },
  { url: "/images/profiles/Christie.png", label: "Christie - Account Manager" },
  { url: "/images/profiles/lisa.png", label: "Lisa - Support Specialist" },
  { url: "/images/profiles/Rebecca.png", label: "Rebecca - Senior Professional" },
  { url: "/images/profiles/Sam.png", label: "Sam - Executive Professional" },
  { url: "/images/profiles/Denise.webp", label: "Denise - Patient Coordinator" },
  { url: "/images/profiles/Mary.webp", label: "Mary - Office Manager" },
  { url: "/images/profiles/dua.webp", label: "Dua - Client Success Manager" },
  { url: "/images/profiles/Andrew.webp", label: "Andrew - Sales Representative" },
  { url: "/images/profiles/Ben.webp", label: "Ben - Business Development" },
  { url: "/images/profiles/Rob.webp", label: "Rob - Account Executive" },
  { url: "/images/profiles/Mia.png", label: "Mia - Live Chat Support Agent" },
  { url: "/images/profiles/Evelyn.png", label: "Evelyn - Office Professional" },
  { url: "/images/profiles/William.png", label: "William - Senior Executive" },
  { url: "/images/profiles/Leo.png", label: "Leo - Support Specialist" },
  { url: "/images/profiles/Astrid.png", label: "Astrid - Customer Support" },
  { url: "/images/profiles/Janathan.png", label: "Janathan - Business Professional" },
  { url: "/images/profiles/Katie.png", label: "Katie - Client Services Rep" },
];

export const DEFAULT_AGENT_PROFILE_PRESET = AGENT_PROFILE_PRESETS[2]!;

/** Preset first names that present as male (for balanced Trish suggestions). */
export const MALE_AGENT_PRESET_NAMES = new Set([
  "andrew",
  "ben",
  "rob",
  "sam",
  "william",
  "leo",
  "janathan",
]);

export function isMaleAgentPreset(preset: AgentProfilePreset): boolean {
  const { agentName } = parseAgentPresetLabel(preset.label);
  return MALE_AGENT_PRESET_NAMES.has(agentName.toLowerCase());
}

export function parseAgentPresetLabel(label: string): {
  agentName: string;
  titleHint: string;
} {
  const dash = label.indexOf(" - ");
  if (dash === -1) {
    return { agentName: label.trim(), titleHint: "" };
  }
  return {
    agentName: label.slice(0, dash).trim(),
    titleHint: label.slice(dash + 3).trim(),
  };
}

export function presetFromUrl(url: string): AgentProfilePreset | undefined {
  return AGENT_PROFILE_PRESETS.find((p) => p.url === url);
}
